import { useEffect, useRef } from 'react';
import {
  isConnectorAvailable,
  onAuthHealth,
  tryGetAuthHealth,
} from '../lib/connector';
import { applyAuthHealthPayload } from '../lib/authHealth';

/**
 * Connector `auth:health` event + one boot `get_auth_health()` query.
 * No polling — pre-PR#24 Connectors feature-detect as unsupported.
 */
export default function AuthHealthBridge() {
  const unlistenRef = useRef(null);
  const bootQueriedRef = useRef(false);

  useEffect(() => {
    if (!isConnectorAvailable()) return undefined;

    let cancelled = false;

    const bootQuery = async () => {
      if (bootQueriedRef.current || cancelled) return;
      bootQueriedRef.current = true;
      const outcome = await tryGetAuthHealth();
      if (cancelled || outcome.kind !== 'ok') return;
      applyAuthHealthPayload(outcome.health);
    };

    const subscribe = async () => {
      if (cancelled) return;
      try {
        const unlisten = await onAuthHealth((payload) => {
          applyAuthHealthPayload(payload);
        });
        if (cancelled) {
          if (typeof unlisten === 'function') unlisten();
          return;
        }
        unlistenRef.current = unlisten;
      } catch (err) {
        console.warn('[AuthHealthBridge] listen failed:', err);
      }
    };

    void bootQuery();
    void subscribe();

    return () => {
      cancelled = true;
      if (typeof unlistenRef.current === 'function') {
        unlistenRef.current();
      }
      unlistenRef.current = null;
    };
  }, []);

  return null;
}
